/*
  Maison Ella — carrossel horizontal com setas (.pdpb-rail).
  Usado nas fotos das reviews e no COMPLETE THE LOOK. Trilho com scroll-snap
  nativo (arrasta no telemóvel); as setas só aparecem quando há para onde ir.
*/
(() => {
  if (window.pdpbRail) return;

  const update = (rail) => {
    const track = rail && rail.querySelector('[data-rail-track]');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (prev) prev.hidden = track.scrollLeft <= 2;
    if (next) next.hidden = track.scrollLeft >= max;
  };
  const updateAll = () => document.querySelectorAll('.pdpb-rail').forEach(update);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rail-prev], [data-rail-next]');
    if (!btn) return;
    const track = btn.closest('.pdpb-rail').querySelector('[data-rail-track]');
    const item = track.firstElementChild;
    const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    const dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    (e) => {
      const t = e.target;
      if (t instanceof Element && t.matches('[data-rail-track]')) update(t.closest('.pdpb-rail'));
    },
    { capture: true, passive: true }
  );

  window.pdpbRail = { update: updateAll };
  updateAll();
  window.addEventListener('resize', updateAll, { passive: true });
  window.addEventListener('load', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
})();
